import tagTester from './_tagTester.js';

export default tagTester('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isWeakSet.js
// module id = 1021
// module chunks = 0